import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTrackingStore } from '../stores/trackingStore';

const StatusPage: React.FC = () => {
  const navigate = useNavigate();
  const { isTracking, lastLocation, activeTargets, nativeTargets, trackingError } =
    useTrackingStore();

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
        <div className="text-center">
          <div className={`w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center ${
            isTracking ? 'bg-green-100' : 'bg-gray-100'
          }`}>
            <span className="text-3xl">
              {isTracking ? '🚗' : '⏸️'}
            </span>
          </div>

          <h1 className="text-2xl font-bold mb-2">
            {isTracking ? 'Rastreamento Ativo' : 'Rastreamento Parado'}
          </h1>

          {trackingError && (
            <div className="error-box text-sm text-left">{trackingError}</div>
          )}

          {isTracking && (
            <>
              <p className="text-gray-600 mb-4">
                {activeTargets.length} rastreamento(s) ativo(s)
              </p>

              <div className="bg-gray-50 rounded p-4 mb-4 text-left">
                <p className="text-sm text-gray-600 mb-2">Ativos agora:</p>
                <ul className="text-xs text-gray-500 space-y-1">
                  {activeTargets.map((t) => (
                    <li key={`${t.osId}-${t.faseId}`}>
                      OS {t.osId} • Fase {t.faseId}
                    </li>
                  ))}
                </ul>
              </div>

              {lastLocation && (
                <div className="bg-gray-50 rounded p-4 mb-4">
                  <p className="text-sm text-gray-600">Última localização:</p>
                  <p className="text-xs text-gray-500 mt-1">
                    {lastLocation.lat.toFixed(6)}, {lastLocation.lng.toFixed(6)}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    {new Date(lastLocation.timestamp).toLocaleTimeString()}
                  </p>
                </div>
              )}
            </>
          )}

          {nativeTargets.length > 0 && (
            <div className="bg-gray-50 rounded p-4 mb-4 text-left">
              <p className="text-sm text-gray-600 mb-2">Rastreadas pelo app nativo:</p>
              <ul className="text-xs text-gray-500 space-y-1">
                {nativeTargets.map((t) => (
                  <li key={`${t.osId}-${t.faseId}`}>
                    OS {t.osId} • Fase {t.faseId}
                  </li>
                ))}
              </ul>
            </div>
          )}

          <p className="text-sm text-gray-500 mt-4">
            {isTracking
              ? 'O navegador envia sua localização enquanto esta tela estiver aberta. Se minimizar, desligar a tela ou abrir o Maps/Waze, o envio pausa até você voltar.'
              : 'Inicie uma fase para começar o rastreamento.'}
          </p>

          <button
            type="button"
            className="btn-secondary w-full mt-4"
            onClick={() => navigate('/dashboard')}
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusPage;
